<ng-container *ngIf="viewModel$ | async as vm">
  <ng-container *ngIf="!vm.webRequest">
    <div class="border border-secondary rounded flex-grow-1">
      <iframe #scriptFrame sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
        class="h-100 w-100" src="/assets/scripting/index.html" style="border: 0" title="scriptFrame"
        (load)="onScriptFrameLoad(scriptFrame)"></iframe>
    </div>
    <form *ngIf="vm.inputs && vm.formGroup" [formGroup]="vm.formGroup" class="mt-2" autocomplete="off" novalidate>
      <ng-container *ngIf="vm.inputs.type === 'matrix'">
        <div *ngFor="let row of vm.inputs.rows; index as r" class="form-row">
          <div *ngIf="vm.inputs.rows.length > 1 && !!row" class="col-auto d-flex flex-column"
            [ngClass]="{ 'first-row-label': r==0, 'second-row-label': r>0}">{{row}}</div>
          <ng-container *ngFor="let col of vm.inputs.columns | asArray; index as c">
            <div *ngIf="col.visible" class="col-auto form-group">
              <app-question-input id="q{{ vm.qNo }}r{{ r }}c{{ c }}" [control]="getControl(vm.formGroup, r, c)!"
                [input]="col" [showColumnLabel]="r == 0"></app-question-input>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="vm.inputs.type !== 'matrix' && vm.inputs.visible">
        <app-question-input id="q{{ vm.qNo }}" [control]="getControl(vm.formGroup)!" [input]="vm.inputs"
          [showColumnLabel]="true"></app-question-input>
      </ng-container>
      <div class="form-row d-flex justify-content-between pt-1">
        <div class="col-auto">
          <button type="button" class="btn btn-secondary w-8rem" (click)="back()" [disabled]="vm.noNavBack">
            Back
          </button>
          <button type="submit" class="btn btn-primary w-8rem ml-1" [disabled]="vm.formGroup.invalid"
            (click)="next(vm.formGroup)">
            Next
          </button>
        </div>
        <div class="col-auto d-flex flex-column-reverse">
          <span>Question {{ vm.qNo }}</span>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-container *ngIf="vm.webRequest">
    <div class="border border-secondary rounded flex-grow-1">
      <iframe class="h-100 w-100" [src]="vm.webRequest"
        sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox allow-forms allow-same-origin"
        style="border: 0" title="webCapture"></iframe>
    </div>
    <form class="mt-2">
      <div class="form-row d-flex justify-content-between">
        <div class="col-auto">
          <button type="button" class="btn btn-secondary" (click)="closeWebCapture()">
            Close
          </button>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>